import React, { ReactNode } from 'react'
import { DocumentOutlineSection } from 'react-document-section'

import HeadingBlockElement from '../content-blocks/heading'
import { TitleResolver } from '../types'

import structureData from './structure-data'
import { HeadingBlock, NonHeadingBlock } from './types'

export interface WithDocumentOutlineSectionProps {
  nodes: ReactNode
  resolveTitle?: TitleResolver
}

const renderRTFDocumentSection = (
  structuredData: HeadingBlock,
  resolveTitle: TitleResolver
) => {
  const { key, children, level, slugified, content } = structuredData
  return (
    <DocumentOutlineSection key={key} title={resolveTitle(children, level)}>
      <HeadingBlockElement slugified={slugified} />
      {/* eslint-disable-next-line @typescript-eslint/no-use-before-define */}
      {renderRTFDocumentSectionContent(content, resolveTitle)}
    </DocumentOutlineSection>
  )
}

const renderRTFDocumentSectionContent = (
  nodes: (NonHeadingBlock | HeadingBlock)[],
  resolveTitle: TitleResolver
) => {
  return nodes.map((node) => {
    return node.isHeadingBlock
      ? renderRTFDocumentSection(node, resolveTitle)
      : node.block
  })
}

const defaultTitleResolver: TitleResolver = (title) => title

const WithDocumentOutlineSection = ({
  nodes: data = [],
  resolveTitle = defaultTitleResolver,
}: WithDocumentOutlineSectionProps) => {
  if (!Array.isArray(data)) {
    return React.isValidElement(data) ? data : null
  }

  const [structuredData] = structureData(data, 0, {
    isHeadingBlock: true,
    level: 1,
    slugified: '',
    key: '',
    content: [],
  })

  return (
    <>{renderRTFDocumentSectionContent(structuredData.content, resolveTitle)}</>
  )
}

export default WithDocumentOutlineSection
